"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopUp = void 0;
const mapbox_gl_1 = __importDefault(require("mapbox-gl"));
const react_1 = __importDefault(require("react"));
const server_1 = require("react-dom/server");
const uuid_1 = require("./uuid");
const context_1 = require("./context");
const PopUpComponent = ({ id = (0, uuid_1.uuidv4)(), lnglat, map, closeButton, closeOnClick, children, }) => {
    const [popup, setPopup] = react_1.default.useState(null);
    const [newLnglat, setNewLnglat] = react_1.default.useState(undefined);
    const [newHtml, setNewHtml] = react_1.default.useState(undefined);
    react_1.default.useEffect(() => {
        if (!popup) {
            const popupNew = new mapbox_gl_1.default.Popup({
                closeButton: closeButton,
                closeOnClick: closeOnClick,
            });
            const htmlString = (0, server_1.renderToString)(children);
            popupNew.setLngLat(lnglat).setHTML(htmlString).addTo(map);
            setPopup(popupNew);
            setNewLnglat(lnglat);
            setNewHtml(htmlString);
        }
        return () => {
            if (popup) {
                popup.remove();
            }
        };
    }, [popup, setPopup, setNewLnglat, setNewHtml]);
    if (popup) {
        const htmlString = (0, server_1.renderToString)(children);
        if (htmlString !== newHtml) {
            setNewHtml(htmlString);
            popup.setHTML(htmlString);
            // console.log({ htmlString, newHtml });
        }
        else if (lnglat !== newLnglat) {
            setNewLnglat(lnglat);
            popup.setLngLat(newLnglat);
        }
    }
    return null;
};
exports.PopUp = (0, context_1.withMap)(PopUpComponent);
//# sourceMappingURL=popup.js.map